export default __webpack_public_path__ + "0bf7f0e9e58bbe170437ab7fa8d81353.svg";